export default __webpack_public_path__ + "static/media/settings permission.97b433c7.png";